const { CREATE_INCOME_RANGE, CREATE_INCOME_RANGE_SUCCESS, CREATE_INCOME_RANGE_FAIL, UPDATE_INCOME_RANGE, UPDATE_INCOME_RANGE_SUCCESS, UPDATE_INCOME_RANGE_FAIL } = require("./Constants");

const initialState = {
    Loading: false,
    errors: "",
    successMsg: ""
}

const ManageIncomeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_INCOME_RANGE:
            return {
                ...state,
                Loading: true,
                errors: "",
                successMsg: ""
            }
        case CREATE_INCOME_RANGE_SUCCESS:
            return {
                ...state,
                Loading: false,
                successMsg: action.payload
            }

        case CREATE_INCOME_RANGE_FAIL:
            return {
                ...state,
                Loading: false,
                errors: action.payload,
            }


        case UPDATE_INCOME_RANGE:
            return {
                ...state,
                Loading: true,
                errors: "",
                successMsg: ""
            }
        case UPDATE_INCOME_RANGE_SUCCESS:
            return {
                ...state,
                Loading: false,
                successMsg: action.payload
            }

        case UPDATE_INCOME_RANGE_FAIL:
            return {
                ...state,
                Loading: false,
                errors: action.payload,
            }

        default:
            return state
    }
}

export default ManageIncomeReducer;